import { Form } from 'antd'
import { useRecoilState } from 'recoil'
import message from '@/libs/message'
import createClaimApprovalModalAtom from '../../../../../recoil/createClaimApprovalModal/atom'

import { useMemo, useState } from 'react'
import { useListHealthClaimApproveLevel } from '@/services/healthClaim/useListHealthClaimApproveLevel'
import { useCreateUserApprovalCondition } from '@/services/healthClaim/useCreateUserApprovalCondition'

export default function DeleteApprovalModalHook() {
  const [createClaimApprovalModal, setCreateClaimApprovalModal] = useRecoilState(
    createClaimApprovalModalAtom,
  )
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true)
  const queryListHealthClaimUserApprove = useListHealthClaimApproveLevel()

  const { mutateAsync: createUserApprovalConditionMutate, isPending: isPendingApproval } =
    useCreateUserApprovalCondition()

  const [form] = Form.useForm()

  type OnSubmitProps = {
    backofficeUserId: string
    approvalConditionId: string
  }

  const userValue = Form.useWatch('userValue', form)
  const watchApprovalConditionId = Form.useWatch('approvalConditionId', form)

  const onFinish = async (values: any) => {
    const payload: OnSubmitProps = {
      backofficeUserId: values.userValue[0].value,
      approvalConditionId: values.approvalConditionId,
    }

    await createUserApprovalConditionMutate(payload)
      .then(() => {
        onCancelModal()

        if (createClaimApprovalModal?.onSuccess) createClaimApprovalModal.onSuccess()
        return message.success('เพิ่มผู้อนุมัติสำเร็จ')
      })
      .catch(() => {
        return message.error({
          content: `เกิดข้อผิดพลาด`,
          duration: 10,
        })
      })
  }

  // Shared function to validate and update submit disabled state
  const updateSubmitDisabledState = () => {
    const hasErrors = form.getFieldsError().some(({ errors }) => errors.length > 0)
    const values = form.getFieldsValue(['userValue', 'approvalConditionId'])
    const allFilled = ['userValue', 'approvalConditionId'].every((k) => {
      const v = (values as any)[k]
      return v !== undefined && v !== null && v !== ''
    })
    setIsSubmitDisabled(!allFilled || hasErrors)
  }

  const onCancelModal = () => {
    setIsSubmitDisabled(true)
    form.setFieldsValue({
      userValue: null,
      approvalConditionId: undefined,
    })
    setCreateClaimApprovalModal({
      open: false,
    })
  }

  const onHandleSubmit = async () => {
    try {
      const values = await form.validateFields()
      await onFinish(values) // reuse handler ที่ทำ API/close modal
    } catch {
      // validation failed -> keep modal open
      onCancelModal()
    }
  }

  // Reset form fields when modal is closed
  useMemo(() => {
    if (!createClaimApprovalModal.open) {
      form.resetFields()
    }
  }, [createClaimApprovalModal.open, form])

  return {
    createClaimApprovalModal,
    onCancelModal,
    queryListHealthClaimUserApprove,
    form,
    userValue,
    onFinish,
    onHandleSubmit,
    isPendingApproval,
    watchApprovalConditionId,
    isSubmitDisabled,
    setIsSubmitDisabled,
    updateSubmitDisabledState,
  }
}
